
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `Нажмите «Открыть в браузере…»`,
's182ab2d6c997515f': `Добавьте его на экран «Домой» — это откроет дополнительные возможности и сделает использование удобнее.`,
's224cbcec014ef6b5': `Нажмите "Поделиться"`,
's233af3b7eb5e0364': `Добавить ярлык на телефон`,
's37a9e8aec5713460': `Подробнее`,
's4c3161035f3a1413': `Нажмите «Меню»`,
's4e1e10a6ca408245': `Нажмите "Добавить на главный экран"`,
's6196153c4b0c1ea0': `Установить`,
's633502f7cff4f847': `Откройте меню вашего браузера`,
's681e399d63311fba': `Показать галерею`,
's6d14a4f70ba4e3cf': `Нажмите «Меню», если нет значка «Поделиться»`,
's922329d6f6213590': `Добавить в Dock`,
's9c63a79ffcc2a3a3': `Нажмите "На экран «Домой»"`,
'sa2d71bfd9525168d': `Нажмите "Добавить в Dock"`,
'sa5ef80b4bb9b39f8': `Свернуть`,
'sb527eca1c1d7e7be': `Откройте меню встроенного браузера`,
'sba52286c21552a4e': `Установите это на ваше устройство, чтобы получить дополнительные возможности и удобство использования.`,
'sc16e00a7a8b2fde2': `Назад`,
'scdaf4bbff76674c8': `На экран «Домой»`,
'sd18a5b85f599ff3c': `Откройте скопированную ссылку в Safari`,
'se72fc3a84f9b51c3': `Нажмите, чтобы скопировать ссылку`,
'se740f75b95a51807': `Добавьте его в Dock — это откроет дополнительные возможности и сделает использование удобнее.`,
'sfa6c42cdf48d93d2': `Но этот браузер не поддерживает эту функцию. Чтобы продолжить, откройте ссылку во внешнем браузере.`,
'sfb78526365796a41': `Нажмите "Показать еще" в меню "Поделиться"`,
'sfea652f6580ff086': `Этот веб-сайт имеет функционал приложения.`,
    };
  